import { render, staticRenderFns } from "./OfferInfo.vue?vue&type=template&id=6f2c2c40&scoped=true"
var script = {}
import style0 from "./OfferInfo.vue?vue&type=style&index=0&id=6f2c2c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c2c40",
  null
  
)

export default component.exports